// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-simple{display:inline-block;height:40px;padding:0 15px;font-family:\"GothamSSm-Bold\",Arial,sans-serif;font-size:14px;text-transform:uppercase;outline:0;border-radius:20px;color:#9a66bf}.button-simple.mini{height:30px;font-size:12px;border-radius:15px}.button-simple.stroke{border:2px solid #9a66bf}.button-simple.fill{background-color:#9a66bf;color:white}.button-simple.transparent{background-color:transparent}\n", ""]);
// Exports
module.exports = exports;
